// src/pages/Home.jsx
import { Link } from 'react-router-dom';

const HeartIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="#2e7d32" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-10 h-10">
    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
  </svg>
);
const LeafIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="#2e7d32" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-10 h-10">
    <path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10z"/>
    <path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12"/>
  </svg>
);
const CheckCircleIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="#2e7d32" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-10 h-10">
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/>
  </svg>
);
const CalendarIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="#2e7d32" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-10 h-10">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
    <line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
  </svg>
);
const SmallCheck = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="#2e7d32" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4 flex-shrink-0 mt-0.5">
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/>
  </svg>
);

const WHY_ITEMS = [
  { Icon: HeartIcon,       title: 'Longer Plant Life',  desc: 'Expert care extends the lifespan of your plants significantly.' },
  { Icon: LeafIcon,        title: 'Healthier Growth',   desc: 'Proper nutrition and pruning ensure vibrant, lush growth.' },
  { Icon: CheckCircleIcon, title: 'Pest Prevention',    desc: 'Regular inspections catch and prevent pest infestations early.' },
  { Icon: CalendarIcon,    title: 'Expert Advice',      desc: 'Get personalized care tips for each plant in your collection.' },
];

const PACKAGES = [
  {
    name: 'Basic', range: 'For 1-10 pots', price: '₹600', tagline: 'Perfect for small balconies',
    features: ['Soil loosening and aeration', 'Fertilizer application', 'Light pruning and cleaning', 'Basic pest inspection'],
  },
  {
    name: 'Standard', range: 'For 11-20 pots', price: '₹900', tagline: 'For medium plant collections',
    features: ['All Basic services', 'Deep pruning and shaping', 'Detailed pest check and treatment', 'Plant health consultation', 'Care tips for each plant'],
  },
  {
    name: 'Premium', range: 'For 21+ pots', price: '₹1200', tagline: 'Complete plant care solution',
    features: ['All Standard services', 'Repotting assistance', 'Customized care plan', 'Before/after photos', 'Plant Placement Advice', 'WhatsApp support for 1 month'],
  },
];

const HOW_STEPS = [
  { num: '1', title: 'Book Online',          desc: 'Select your package and preferred date on our website.' },
  { num: '2', title: 'Confirm Date',         desc: 'We confirm your booking and provide service time window.' },
  { num: '3', title: 'We Visit',             desc: 'Our experts provide professional care to all your plants.' },
  { num: '4', title: 'Enjoy Healthy Plants', desc: 'Your plants thrive with regular professional maintenance.' },
];

// ── Disclaimer Note Component ──────────────────────────────────
function DisclaimerNote() {
  return (
    <div className="max-w-5xl mx-auto mt-10 mx-4">
      <div className="bg-blue-50 border border-blue-200 rounded-2xl p-5">
        {/* Header */}
        <div className="flex items-center gap-2 mb-4">
          <span className="text-lg">📋</span>
          <h3 className="font-bold text-gray-900 text-sm">Please Note — Service Information</h3>
        </div>
        {/* Notes */}
        <ul className="space-y-3">
          <li className="flex items-start gap-3">
            <span className="flex-shrink-0 w-5 h-5 bg-green-100 rounded-full flex items-center justify-center mt-0.5">
              <svg viewBox="0 0 24 24" fill="none" stroke="#2e7d32" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="w-3 h-3">
                <polyline points="20 6 9 17 4 12"/>
              </svg>
            </span>
            <p className="text-sm text-gray-700">
              <span className="font-semibold text-gray-900">Basic fertilizer is included</span> in all service packages at no extra charge.
            </p>
          </li>
          <li className="flex items-start gap-3">
            <span className="flex-shrink-0 w-5 h-5 bg-red-100 rounded-full flex items-center justify-center mt-0.5">
              <svg viewBox="0 0 24 24" fill="none" stroke="#dc2626" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="w-3 h-3">
                <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
              </svg>
            </span>
            <p className="text-sm text-gray-700">
              <span className="font-semibold text-gray-900">Premium fertilizers and pesticides</span> are charged extra if required, based on plant condition.
            </p>
          </li>
          <li className="flex items-start gap-3">
            <span className="flex-shrink-0 w-5 h-5 bg-yellow-100 rounded-full flex items-center justify-center mt-0.5">
              <svg viewBox="0 0 24 24" fill="none" stroke="#d97706" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="w-3 h-3">
                <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
                <line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
              </svg>
            </span>
            <p className="text-sm text-gray-700">
              <span className="font-semibold text-gray-900">Large pots (18"+), terrace gardens, vertical gardens, and commercial spaces</span> may require a custom quote.
            </p>
          </li>
        </ul>
        {/* Contact */}
        <div className="mt-4 pt-4 border-t border-blue-200 flex flex-col sm:flex-row items-start sm:items-center gap-2">
          <p className="text-xs text-gray-500 flex-1">For custom pricing or large space requirements, contact us directly.</p>
          <a href="tel:+917302472992"
            className="flex items-center gap-1.5 px-3 py-1.5 bg-[#2e7d32] text-white text-xs font-semibold rounded-lg hover:bg-[#1b5e20] transition-colors whitespace-nowrap">
            📞 +91-7302472992
          </a>
        </div>
      </div>
    </div>
  );
}

export default function Home() {
  return (
    <div>
      {/* Location bar */}
      <div className="bg-green-50 border-b border-green-100 text-center py-2 text-sm text-gray-600 mt-16">
        Serving <span className="font-semibold text-gray-800">Ulwe, Navi Mumbai - 410206</span>
      </div>

      {/* Hero */}
      <section className="bg-[#2e7d32] text-white py-24 px-4">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight mb-6">
            Transform Your Balcony Into A Green Paradise
          </h1>
          <p className="text-green-100 text-lg sm:text-xl mb-10 max-w-xl mx-auto leading-relaxed">
            Professional plant maintenance service for your balcony. Expert care, affordable pricing - We keep your plants thriving.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/book" className="px-8 py-4 rounded-xl border-2 border-white text-white font-semibold text-base hover:bg-white hover:text-[#2e7d32] transition-all duration-200">
              Book Maintenance Service
            </Link>
            <Link to="/shop" className="px-8 py-4 rounded-xl bg-white text-[#2e7d32] font-semibold text-base hover:bg-green-50 transition-all duration-200 shadow-md">
              Shop Plants
            </Link>
          </div>
        </div>
      </section>

      {/* Why Professional */}
      <section className="bg-white py-20 px-4">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 text-center mb-14">Why Professional Plant Maintenance?</h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10 text-center">
            {WHY_ITEMS.map(({ Icon, title, desc }) => (
              <div key={title} className="flex flex-col items-center">
                <div className="mb-4"><Icon /></div>
                <h3 className="font-bold text-gray-900 text-base mb-2">{title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Service Packages */}
      <section className="bg-gray-50 py-20 px-4">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 text-center mb-3">Our Service Packages</h2>
          <p className="text-gray-500 text-center mb-12">Choose the package that fits your balcony garden.</p>
          <div className="grid sm:grid-cols-3 gap-6">
            {PACKAGES.map(({ name, range, price, tagline, features }) => (
              <div key={name} className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
                <div className="bg-[#2e7d32] px-6 py-5">
                  <h3 className="text-white font-bold text-xl">{name}</h3>
                  <p className="text-green-200 text-sm mt-0.5">{range}</p>
                </div>
                <div className="px-6 py-6">
                  <span className="text-4xl font-bold text-gray-900">{price}</span>
                  <p className="text-gray-500 text-sm mt-1 mb-5">{tagline}</p>
                  <p className="font-semibold text-gray-800 text-sm mb-3">Includes:</p>
                  <ul className="space-y-2 mb-6">
                    {features.map(f => (
                      <li key={f} className="flex items-start gap-2 text-sm text-gray-600">
                        <SmallCheck />{f}
                      </li>
                    ))}
                  </ul>
                  <Link to="/book" className="block w-full text-center bg-[#2e7d32] text-white font-semibold py-3 rounded-xl hover:bg-[#1b5e20] transition-colors duration-200">
                    Book Now
                  </Link>
                </div>
              </div>
            ))}
          </div>

          {/* ── Disclaimer Note ── */}
          <DisclaimerNote />

        </div>
      </section>

      {/* How It Works */}
      <section className="bg-white py-20 px-4">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 text-center mb-14">How Our Service Works</h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 text-center">
            {HOW_STEPS.map(({ num, title, desc }) => (
              <div key={num} className="flex flex-col items-center">
                <div className="w-14 h-14 rounded-full bg-[#2e7d32] text-white flex items-center justify-center text-xl font-bold mb-4 shadow-md">
                  {num}
                </div>
                <h3 className="font-bold text-gray-900 mb-2">{title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Banner */}
      <section className="bg-[#2e7d32] py-16 px-4">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">Ready to Transform Your Balcony?</h2>
          <p className="text-green-100 text-lg mb-8">Book our professional maintenance service today and see the difference!</p>
          <Link to="/book" className="inline-block px-10 py-4 bg-white text-[#2e7d32] font-bold text-base rounded-xl hover:bg-green-50 transition-colors duration-200 shadow-md">
            Book Now
          </Link>
        </div>
      </section>
    </div>
  );
}
